import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/lib/Seo";

export default function NotFound() {
  const { pathname } = useLocation();
  const decoded = decodeURIComponent(pathname);
  const isLibrary = /(الأبحاث|التقارير|research|reports)/i.test(decoded);

  return (
    <>
      <Seo path={pathname} title={isLibrary ? "قريبًا" : "الصفحة غير موجودة"} />
      <section className="min-h-[70svh] bg-paper flex items-center pt-24" data-testid="not-found-page">
        <div className="mx-auto max-w-[800px] px-6 sm:px-10 text-center">
          {isLibrary ? (
            <>
              <span className="eyebrow mb-5 justify-center" style={{ justifyContent: "center" }}>المعرفة</span>
              <h1 className="font-display text-navy leading-tight" style={{ fontSize: "clamp(1.5rem, 2.9vw, 2.3rem)" }}>لا يوجد محتوى منشور هنا بعد</h1>
              <p className="mt-4 text-blue text-lg leading-relaxed">نعمل على إعداد الأبحاث والتقارير. في هذه الأثناء، تصفّح ما نشرناه في مركز المعرفة.</p>
              <Link to="/knowledge" className="mt-8 inline-flex items-center gap-2 bg-coral text-white px-7 py-4 font-semibold" style={{ backgroundColor: "var(--coral)" }}>
                اذهب إلى المعرفة <ArrowLeft size={18} />
              </Link>
            </>
          ) : (
            <>
              <h1 className="font-display text-navy leading-tight" style={{ fontSize: "clamp(1.7rem, 3.3vw, 2.5rem)" }}>الصفحة غير موجودة</h1>
              <p className="mt-4 text-blue text-lg">ربما تغيّر الرابط أو لم يعد متاحًا.</p>
              <Link to="/" className="mt-8 inline-flex items-center gap-2 bg-coral text-white px-7 py-4 font-semibold" style={{ backgroundColor: "var(--coral)" }}>
                العودة إلى الرئيسية <ArrowLeft size={18} />
              </Link>
            </>
          )}
        </div>
      </section>
    </>
  );
}
